import { Button } from "components"
import { TabRegisterPath } from "../../types"
import { PERMISION } from "security"

type TabRegisterProps = {
  activeTab: string
  setActiveTab: (path: string) => void
}

type Tabs = {
  label: string
  path: TabRegisterPath
  permission: string
}

export function TabNavRegister({ activeTab, setActiveTab }: TabRegisterProps) { 
  const tabs: Tabs[] = [
    { label: "By Date Range", path: "by-date-range", permission: PERMISION.PURCHASES.REGISTER.BY_DATE_RANGE.PERMISION },
    { label: "By Card", path: "by-card", permission: PERMISION.PURCHASES.REGISTER.BY_CARD.PERMISION },
    { label: "By Location", path: "by-location", permission: PERMISION.PURCHASES.REGISTER.BY_LOCATION.PERMISION },
    { label: "By Reference Id", path: "reference-id", permission: PERMISION.PURCHASES.REGISTER.BY_REFERENCE_ID.PERMISION },
    { label: "Bills Item", path: "bills-item", permission: PERMISION.PURCHASES.REGISTER.BILLS_ITEM.PERMISION },
    { label: "Bills Service", path: "bills-service", permission: PERMISION.PURCHASES.REGISTER.BILLS_SERVICE.PERMISION },
    { label: "Aged Payable", path: "aged-payable", permission: PERMISION.PURCHASES.REGISTER.AGED_PAYABLE.PERMISION },
    { label: "Work Order", path: "work-order", permission: PERMISION.PURCHASES.REGISTER.WORK_ORDER.PERMISION },
    { label: "Received Rejected", path: "received-rejected", permission: PERMISION.PURCHASES.REGISTER.RECEIVED_REJECTED.PERMISION },
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto">
      {tabs.map((tab) => (
        <Button
          key={tab?.path}
          type="button"
          color="ghost"
          size="sm"
          permission={tab?.permission}
          className={`grow bg-[#3c3c3c] border-y-0 border-x border-white no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab?.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
